export default "__VITE_ASSET__BmLMmK1X__"